import { io } from "socket.io-client";
import { backendUrl } from "../../Router/constant";

let socket = null;

export const connectSocket = () => {
  const token = localStorage.getItem("authToken"); // 👈 web token

  if (!token) {
    console.warn("❌ No auth token found for socket");
    return null;
  }

  socket = io(backendUrl, {
    transports: ["websocket"],
    auth: {
      token,
    },
  });

  socket.on("connect", () => {
    console.log("🟢 Socket connected");
  });

  socket.on("disconnect", () => {
    console.log("🔴 Socket disconnected");
  });

  socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
  });

  return socket;
};

export const getSocket = () => socket;
